import { Injectable, inject } from '@angular/core'
import { type Observable } from 'rxjs'

import { GraphService } from 'src/app/shared/lib/api/graph.service'

import {
  type BankAccount,
  type BankAccountLastMovement
} from '../model/bank-account.model'

const GET_BANK_ACCOUNTS = `query {
  getAllCuentas { id tipo nombre descripcion saldo }
}`

const GET_LAST_MOVEMENTS_BY_ACCOUNT = `query {
  getLastTransactionByAccount { cuentaId banco lastMovementCreatedAt }
}`

@Injectable({ providedIn: 'root' })
export class BankAccountApi {
  private readonly graphQL = inject(GraphService)

  getAll (): Observable<{ getAllCuentas: BankAccount[] }> {
    return this.graphQL.queryGraphQL<{ getAllCuentas: BankAccount[] }>({
      query: GET_BANK_ACCOUNTS,
      variables: {}
    })
  }

  getLastMovements (): Observable<{
    getLastTransactionByAccount: BankAccountLastMovement[]
  }> {
    return this.graphQL.queryGraphQL<{
      getLastTransactionByAccount: BankAccountLastMovement[]
    }>({
      query: GET_LAST_MOVEMENTS_BY_ACCOUNT,
      variables: {}
    })
  }
}
